export const SUPPORT_FORM_OPEN = 'at/support/SUPPORT_FORM_OPEN'
export const SUPPORT_FORM_CLOSE = 'at/support/SUPPORT_FORM_CLOSE'
export const LOADING_START = 'at/support/LOADING_START'
export const LOADING_STOP = 'at/support/LOADING_STOP'
export const SUPPORT_FORM_POSITION_SET = 'at/support/SUPPORT_FORM_POSITION_SET'
export const SUPPORT_FORM_MODE_SET = 'at/support/SUPPORT_FORM_MODE_SET'
export const SUPPORT_FORM_TEXT_SET = 'at/support/SUPPORT_FORM_TEXT_SET'
export const SUPPORT_FORM_ATTACHMENT_ID_SET = 'at/support/SUPPORT_FORM_ATTACHMENT_ID_SET'
export const SUPPORT_FORM_ATTACHMENT_NAME_SET = 'at/support/SUPPORT_FORM_ATTACHMENT_NAME_SET'
export const SUPPORT_FORM_EMAIL_SET = 'at/support/SUPPORT_FORM_EMAIL_SET'
export const SUPPORT_FORM_RESET = 'at/support/SUPPORT_FORM_RESET'



// WEBPACK FOOTER //
// ./web/js/support/supportForm/actionTypes.js